<script>
import axios from 'axios';

export default class SolicitacoesClientesRepository {
    async getTodas(token) {
        const baseURL = process.env.VUE_APP_API_URL + "solicitacoes-clientes";
        const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json' };
        return await axios.get(baseURL, { headers });
    }

    async assumirSolicitacao(token, id) {
        const baseURL = process.env.VUE_APP_API_URL + `solicitacoes-clientes/${id}/assumir`;
        const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json' };
        return await axios.post(baseURL, {}, { headers });
    }

    async updateStatus(token, id, status) {
        const baseURL = process.env.VUE_APP_API_URL + `solicitacoes-clientes/${id}`;
        const headers = { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'Content-Type': 'application/json' };
        return await axios.put(baseURL, { status: status }, { headers });
    }
}
</script>
